import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import ExperiencePageTrendingDestinations from 'components/Experiences/ExperiencesPage/ExperiencesPageTrendingDestinations'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import LocationFloatingPanel from 'components/SearchV2/Components/Mobile/Panels/LocationFloatingPanel'
import ExperienceCategoryPanel from '../Panels/ExperienceCategoryPanel'
import { SearchMenuStates } from 'components/Search/type'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import ExperienceSearchCategoryField from 'components/Experiences/ExperiencesSearch/ExperienceSearchBar/ExperienceSearchCategoryField'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { EXPERIENCE_SEARCH_TYPES } from 'constants/experience'

interface Props {
  closeSearch: () => void
  onSearch: () => void
  isInPage?: boolean
}

function ExperiencesTabContent(props: Props) {
  const { closeSearch, isInPage } = props
  const intl = useIntl()

  const {
    searchItem,
    activeMenu,
  } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const toggleLocationModalVisibility = useCallback(() => {
    const nextMenu = activeMenu === SearchMenuStates.Locations ? SearchMenuStates.Closed : SearchMenuStates.Locations
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [activeMenu, searchDispatch])

  const toggleCategorySearchVisibility = useCallback(() => {
    const nextMenu = activeMenu === SearchMenuStates.ExperienceCategories ? SearchMenuStates.Closed : SearchMenuStates.ExperienceCategories
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [activeMenu, searchDispatch])

  return (
    <VerticalSpacer gap={24}>
      <div>
        <LocationFloatingPanel
          isOpen={activeMenu === SearchMenuStates.Locations}
          onClose={toggleLocationModalVisibility}
          onGoBack={toggleLocationModalVisibility}
          onConfirm={toggleLocationModalVisibility}
          searchTypes={EXPERIENCE_SEARCH_TYPES}
        />
        <ExperienceCategoryPanel
          open={activeMenu === SearchMenuStates.ExperienceCategories}
          onClose={toggleCategorySearchVisibility}
        />
        <VerticalSpacer gap={12}>
          <SearchFormField
            label={intl.formatMessage({
              id: 'X68FjoB/Xs',
              defaultMessage: 'Where',
              description: 'Label for experience destination search field',
            })}
            placeholder={intl.formatMessage({
              id: 'bclhuWkOk3',
              defaultMessage: 'Search destination',
              description: 'Placeholder for experience destination search field',
            })}
            value={searchItem?.format.mainText}
            onClick={toggleLocationModalVisibility}
          />
          <ExperienceSearchCategoryField onClick={toggleCategorySearchVisibility} />
        </VerticalSpacer>
      </div>
      {!isInPage && <ExperiencePageTrendingDestinations
        colour="neutral-two"
        weight="normal"
        onClick={closeSearch}
      />}
    </VerticalSpacer>
  )
}

export default ExperiencesTabContent
